// removed by extract-text-webpack-plugin
module.exports = {"root":"Header--root--Yb","cachedRoot":"Header--cachedRoot--3- Header--root--Yb","main":"Header--main--1z","small":"Header--small--1y","fakeButton":"Header--fakeButton--1X","dropdown":"Header--dropdown--2O","dropdownWide":"Header--dropdownWide--yF Header--dropdown--2O","dropdownItem":"Header--dropdownItem--mA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/dropdownStyles.styl
// module id = 222
// module chunks = 0